<template>
  <div class="studio">
    <!-- <STUDIO CREATE OR UPDATE> -->
    <v-dialog v-model="cuDialog" width="850">
      <div style="background-color:white;">
        <studio-c-u
          :isUpdate="isUpdate"
          :dialog="cuDialog"
          :studioId="selectedStudio"
          @closeDialog="closeDialog"
          @addedOrChanged="addedOrChanged"
        ></studio-c-u>
      </div>
    </v-dialog>
    <!-- </STUDIO CREATE OR UPDATE> -->

    <img v-if="isLoading" class="loading-icon" src="../../assets/loading-icon.gif" alt="Loading...">
    <div class="header clearAfterFloats">
      <h2 class="title">
        <h1 class="header-text">
          <span>Studio
            <div class="header-text-line"></div>
          </span>
        </h1>
      </h2>

      <!-- <STUDIO SEARCH> -->
      <div class="studio-search">
        <v-text-field class="search-field" v-model="searchText" label="Pretraga po nazivu"></v-text-field>

        <v-btn v-if="!isSearchActive" @click="filterByName" class="search-btn">
          <v-icon>search</v-icon>
          <span>Pretraga</span>
        </v-btn>

        <v-btn v-else @click="resetFilterObject" class="search-btn">
          <v-icon>close</v-icon>
          <span>Očisti pretragu</span>
        </v-btn>
      </div>
      <!-- </STUDIO SEARCH> -->
      <img
        @click="cuDialog = true"
        src="../../assets/icons/create.png"
        class="action-icon-lg float-right"
        alt="Kreiraj"
      >
    </div>

    <!-- <STUDIO DATA TABLE>-->
    <v-flex xs12>
      <v-data-table :headers="headers" :items="studio" hide-actions class="elevation-1">
        <template slot="items" slot-scope="props">
          <td class="text-xs-left">{{ props.item.Name }}</td>
          <td class="text-xs-left">{{ props.item.Index }}</td>
          <td class="text-xs-center">{{ props.item.IsActive ? 'Da' : 'Ne' }}</td>
          <td class="text-xs-center">
            <img
              @click="setStudioForEdit(props.item.StudioId)"
              src="../../assets/icons/edit.png"
              class="action-icon-sm"
              alt="Uredi"
            >
          </td>
        </template>
      </v-data-table>
    </v-flex>
    <!-- </STUDIO DATA TABLE> -->
  </div>
</template>

<script>
import StudioCreateOrUpdate from "./CreateOrUpdate";
export default {
  components: {
    studioCU: StudioCreateOrUpdate
  },
  data() {
    return {
      //Data table headers
      headers: [
        {
          text: "Naziv",
          value: "naziv",
          align: "left"
        },
        {
          text: "Index",
          value: "index",
          align: "left"
        },
        {
          text: "Aktivan",
          value: "aktivan",
          align: "center"
        },
        {
          text: "Akcije",
          value: "akcije",
          align: "center"
        }
      ],
      studio: [],
      selectedStudio: null,
      isUpdate: false,
      cuDialog: false,
      isLoading: false,
      isSearchActive: false,
      searchText: "",
    };
  },
  methods: {
    getStudio() {
      this.$store.state.services.studioService.getAll().then(response => {
        this.studio = response.data;
      }).catch(err => {
        console.log(err);
      });
    },
    setStudioForEdit(selectedId) {
      this.selectedStudio = selectedId;
      this.isUpdate = true;
      this.cuDialog = true;
    },
    closeDialog() {
      this.cuDialog = false;
      this.isUpdate = false;
    },
    addedOrChanged(response) {
      this.getStudio();
      this.closeDialog();
      this.$store.dispatch("setResponseMessage", response);
    },
    filterByName() {
      if (this.searchText == "") return;

      this.isSearchActive = true;
      this.isLoading = true;
      this.$store.state.services.studioService
        .filterByName(this.searchText)
        .then(response => {
          this.studio = response.data;
          this.isLoading = false;
        });
    },
    resetFilterObject() {
      this.isSearchActive = false;
      this.searchText = "";

      this.getStudio();
    }
  },
  created() {
    this.getStudio();
  }
};
</script>
<style scoped>
.studio {
  padding: 10px 30px;
  position: relative;
}

.title {
  width: 30%;
  float: left;
  font-size: 28px;
  color: #030405;
}

.studio-search {
  width: 50%;
  float: left;
}

.search-field {
  width: 60%;
  float: left;
}

.search-btn {
  float: left;
  margin-left: 20px;
}

.color-container {
  width: 30px;
  height: 30px;
  border-radius: 50%;
}
</style>
